import {Button, Input, notification, Segmented, Select, Space, Spin, Table, Tag, Tooltip} from "antd";
import {CloseOutlined, EyeOutlined, FilterOutlined, ReloadOutlined, SwapOutlined} from "@ant-design/icons";
import moment from "moment";
import {useAuth} from "oidc-react";
import React, {useEffect, useRef, useState} from "react";
import SharedService from "../../../services/shared/service";
import "./EmailQueues.css";
import {useLocation, useNavigate} from "react-router-dom";
import EmailQueueSearchPopup from "../../../components/popups/EmailQueueSearchPopup";
import MoveEmailModal from "../../../components/popups/MoveEmailModal";
import SEO from "../../../components/SEO"
import {formatDate} from "../../../utils/datetime.utils";
import {upperCaseFirstLetter} from "../../../utils/string.utils";
import {jwtDecode} from "jwt-decode";
import {EmailStatusColors} from "../../../constants/status.constants";
import {EmailImportanceColor} from "../../../constants/color.constants";

function EmailQueues() {
    const location = useLocation();


    const pageSEOSettings = {
        title: "Email List",
    };

    const Navigate = useNavigate();
    const [emailQueueData, setEmailQueueData] = useState([]);
    const [open, setOpen] = useState(false);
    const [value, setValue] = useState("");
    const [folder, setFolder] = useState("");
    const [dateRange, setDateRange] = useState([]);
    const [folderListData, setFolderListData] = useState([]);
    const [folderListValue, setFolderListValue] = useState("");
    const [loading, setloading] = useState(false);
    const [emailQueueIsOpen, setEmailQueueIsOpen] = useState(false);
    const [searchCategory, setSearchCategory] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [sortedInfo, setSortedInfo] = useState({});
    const [messageContent, setMessageContent] = useState("");
    const [emailQueueId, setEmailQueueId] = useState("");
    const [messageIdentifier, setMessageIdentifier] = useState("");
    const [emailaddress, setEmailaddress] = useState("");
    const [emailFolder, setEmailFolder] = useState([]);
    const [reviewedIgnoredId, setReviewedIgnoreId] = useState("");
    const [folderName, setFolderName] = useState("");
    const [radioOption, setRadioOption] = useState("");
    const {userData, userManager} = useAuth();
    const token = userData?.access_token;
    const [userName, setUserName] = useState("");

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [isBulkMove, setIsBulkMove] = useState(false);

    const [listPagination, setlistPagination] = useState({
        totalItemCount: 0,
        pageSize: 10,
    });
    const [formData, setFormData] = useState({
        senderEmail: "",
        queueEmail: "",
        fromDate: "",
        toDate: "",
        days: null,
        referenceId: null,
        selectedItems: [],
    });

    useEffect(() => {
        if (token) {
            const decodedToken = jwtDecode(token);
            setUserName(decodedToken.email);
        }
    }, [token, userName, userData]);

    useEffect(() => {
        folderList();
        const storedInboxdropdown = localStorage.getItem("Inboxdropdown");
        if (storedInboxdropdown) {
            setFolderListValue(storedInboxdropdown);
        } else {
            setFolderListValue("");
        }
        return () => {
            localStorage.removeItem("Inboxdropdown");
        };
    }, []);
    useEffect(() => {
        if (folderListValue) {
            localStorage.setItem("Inboxdropdown", folderListValue);
        } else {
            localStorage.removeItem("Inboxdropdown");
        }
    }, [folderListValue]);
    useEffect(() => {
        if (formData.selectedItems && formData.selectedItems.length > 0) {
            fetchQueueEmailData();
        }
    }, [formData.selectedItems]);

    useEffect(() => {
        let currentPageNumber = 1;
        if (location.state && location.state.page) {
            currentPageNumber = location.state?.page;

            window.history.replaceState(null, null, window.location.pathname);
        }
        setlistPagination((prevPagination) => ({
            ...prevPagination,
            pageNumber: currentPageNumber,
        }));
    }, [location]);

    useEffect(() => {
        if (listPagination.pageNumber) fetchQueueEmailData();
    }, [listPagination.pageNumber, sortedInfo]);

    function useSelectedItems(selectedItems, fetchQueueEmailData) {
        const prevSelectedItemsRef = useRef([]);

        useEffect(() => {
            if (
                prevSelectedItemsRef?.current?.length > 0 &&
                selectedItems?.length === 0
            ) {
                fetchQueueEmailData();
            }

            // Save the current selectedItems array for the next comparison
            prevSelectedItemsRef.current = selectedItems;
        }, [selectedItems, fetchQueueEmailData]);
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setSortedInfo(sorter);
        setlistPagination({...listPagination, pageNumber: pagination.current, pageSize: pagination.pageSize});
    };
    const showModal = (id, email, documentid, foldername) => {
        setIsBulkMove(false);
        setEmailaddress(email);
        setEmailQueueId(documentid);
        setMessageIdentifier(id);
        emailFolderReference(email);
        setOpen(true);
        setFolder(foldername);
    };

    const openBulkMoveModal = () => {
        setIsBulkMove(true);

        if (folderListValue.length > 0) {
            // use currently selected queue mailbox
            setEmailaddress(folderListValue);

            emailFolderReference(folderListValue);

            setOpen(true);
        } else {
            notification.error({
                message: "Please select at least one queue mailbox",
            });
        }

    };

    const bulkMoveEmails = async () => {
        setloading(true);
        try {
            await Promise.all(
                selectedRows.map((row) =>
                    SharedService.post({
                        token,
                        url: `user/${row.queueEmail}/messages/internetmessage/${row.messageId}/move`,
                        data: {destinationId: value},
                    })
                )
            );

            await Promise.all(
                selectedRows.map((row) =>
                    SharedService.patch({
                        token,
                        url: `emailValidationQueue/${row.id}`,
                        data: {folder: folderName},
                    })
                )
            );

            notification.success({
                message: `Moved ${selectedRows.length} emails successfully`,
            });

            setSelectedRowKeys([]);
            setSelectedRows([]);
            fetchQueueEmailData();
        } catch (error) {
            notification.error({
                message: "Bulk move failed",
            });
        } finally {
            setloading(false);
        }
    };

    const handleOk = async () => {
        if (isBulkMove) {
            await bulkMoveEmails();
        } else {
            await moveFolder();
        }
        setOpen(false);
    };

    const handleCancel = () => {
        setOpen(false);
        setValue("");
        setFolderName("");
    };

    const paginationProps = {
        defaultPageSize: 20,
        showSizeChanger: true,
        total: listPagination.totalItemCount,
        pageSize: listPagination.pageSize,
        current: listPagination.pageNumber,
    };

    useEffect(() => {
        const storedRadioValue = localStorage.getItem("radioValueemail");
        if (storedRadioValue) {
            setRadioOption(storedRadioValue);
        } else {
            setRadioOption("forReview");
        }
    }, []);
    useEffect(() => {
        const handleBeforeUnload = () => {
            //localStorage.clear();
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);
    useEffect(() => {
        if (radioOption) {
            localStorage.setItem("radioValueemail", radioOption);

            fetchQueueEmailData();
        }
    }, [radioOption]);
    const moveFolder = async () => {
        setloading(true);
        try {
            let data = {
                destinationId: value,
            };

            const response = await SharedService.post({
                token,
                url: `user/${emailaddress}/messages/internetmessage/${messageIdentifier}/move`,
                data,
            });

            // Handle the response data
            if (response)
                if (folderName === "Inbox") {
                    notification.success({
                        message: "Moved successfully to Inbox",
                    });
                    emailValidationQueueStatus();
                } else {
                    notification.success({
                        message: "Moved successfully to Reviewed Ignore",
                    });
                    emailValidationQueueStatus();
                }

            setloading(false);
        } catch (error) {
            setloading(false);
        }
    };

    const emailValidationQueueStatus = async () => {
        try {
            const data = {
                folder: folderName,
            };

            const response = await SharedService.patch({
                token,
                url: `emailValidationQueue/${emailQueueId}`,
                data,
            });
            if (response) {
                fetchQueueEmailData();
            }

            // Handle the response data as per your requirement
            // Close the popup after the API call is completed
        } catch (error) {
            // Handle any errors

            console.error(error);
        }
    };
    const handleColumnClick = (record) => {
        const currentPageNumber = listPagination.pageNumber;
        Navigate(`details/${record.id}`, {state: {page: currentPageNumber}});
    };

    const renderStatusBadge = (status) => {
        if (!status) return null;
        const color = EmailStatusColors[status] || "#7A849A";
        return (
            <span
                className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-md text-[12px] font-medium"
                style={{backgroundColor: `${color}26`, color: "#1B2332"}}
            >
                <span className="w-1.5 h-1.5 rounded-full" style={{backgroundColor: color}}/>
                {upperCaseFirstLetter(status)}
            </span>
        );
    };

    const columns = [
        {
            title: "Ref #",
            dataIndex: "referenceId",
            key: "referenceId",
            width: 100,
            render: (referenceId) => (
                <Tooltip title={referenceId}>
                    <div className="cell-mono font-semibold" style={{color: "var(--primary-color)"}}>
                        {referenceId}
                    </div>
                </Tooltip>
            ),
            sorter: true,
            sortOrder: sortedInfo.columnKey === "referenceId" && sortedInfo.order,
        },
        {
            title: "Subject",
            dataIndex: "subject",
            key: "subject",
            width: 260,
            ellipsis: true,
            render: (subject, record) => (
                <div className="min-w-0">
                    <Tooltip title={subject}>
                        <div className="font-medium truncate text-[#0B1220]">
                            {subject || "(no subject)"}
                        </div>
                    </Tooltip>
                    {record?.senderEmail && (
                        <Tooltip title={record.senderEmail}>
                            <div className="cell-sub truncate">{record.senderEmail}</div>
                        </Tooltip>
                    )}
                </div>
            ),
            sorter: true,
            sortOrder: sortedInfo.columnKey === "subject" && sortedInfo.order,
        },
        {
            title: "Validation Message",
            dataIndex: "text",
            key: "text",
            render: (text) => (
                <Tooltip title={text}>
                    <div className="text-[#374152] line-clamp-2">{text}</div>
                </Tooltip>
            ),
            sorter: true,
            sortOrder: sortedInfo.columnKey === "text" && sortedInfo.order,
        },
        {
            title: "Queue Mailbox",
            dataIndex: "queueEmail",
            key: "queueEmail",
            render: (queueEmail) => {
                if (!queueEmail) return null;
                const emails = queueEmail.split(";");
                return (
                    <Tooltip title={<div style={{whiteSpace: "pre-line"}}>{emails.join("\n")}</div>}>
                        <div className="cell-mono truncate">{queueEmail}</div>
                    </Tooltip>
                );
            },
            sorter: true,
            sortOrder: sortedInfo.columnKey === "queueEmail" && sortedInfo.order,
        },
        {
            title: "Importance",
            dataIndex: "importance",
            key: "importance",
            width: 110,
            render: (importance) => (
                <Tag color={EmailImportanceColor[(importance ?? "normal").toLowerCase()]} className="!m-0">
                    {upperCaseFirstLetter(importance ?? "normal")}
                </Tag>
            ),
            sorter: true,
            sortOrder: sortedInfo.columnKey === "importance" && sortedInfo.order,
        },
        {
            title: "Status",
            dataIndex: "folder",
            key: "folder",
            width: 140,
            render: renderStatusBadge,
            sorter: true,
            sortOrder: sortedInfo.columnKey === "folder" && sortedInfo.order,
        },
        {
            title: "Received",
            dataIndex: "timeStamp",
            key: "timeStamp",
            width: 160,
            render: (timestamp) => (
                <Tooltip title={formatDate(timestamp, 'dd-MMM-yyyy hh:mm tt')}>
                    <div>
                        <div>{formatDate(timestamp, 'dd-MMM-yyyy')}</div>
                        <div className="cell-sub">{formatDate(timestamp, 'hh:mm tt')}</div>
                    </div>
                </Tooltip>
            ),
            sorter: true,
            sortOrder: sortedInfo.columnKey === "timeStamp" && sortedInfo.order,
        },
        {
            title: "",
            align: "right",
            width: 90,
            render: (rec) => (
                <Space size={4} style={{justifyContent: "flex-end", display: "flex"}}>
                    <Tooltip title="Move folder">
                        <Button
                            size="small"
                            type="text"
                            icon={<SwapOutlined/>}
                            onClick={() => showModal(rec.messageId, rec.queueEmail, rec.id, rec.folder)}
                        />
                    </Tooltip>
                    <Tooltip title="View email">
                        <Button
                            size="small"
                            type="text"
                            icon={<EyeOutlined/>}
                            onClick={() => handleColumnClick(rec)}
                        />
                    </Tooltip>
                </Space>
            ),
            key: "Actions",
        },
    ];
    const handleSelectChange = (event) => {
        setSearchCategory(event);
    };

    const handleInputChange = (event) => {
        setInputValue(event.target.value);
    };
    const folderList = async () => {
        setloading(true);
        try {
            const response = await SharedService.get({
                token,
                url: "reference/mailboxes",
            });

            let options = response.map((item) => ({
                label: item.name ?? item.value,
                value: item.value,
                key: item.id,
            }));
            setFolderListData(options);

            setloading(false);
        } catch (error) {
            console.error("EmailQueues Error:", error);
        }
    };

    const emailFolderReference = async (email) => {
        setloading(true);
        try {
            const responseData = await SharedService.get({
                token,
                url: `user/${email}/mailfolders/ocr/status`,
            });
            const filteredResponse = responseData.filter(
                (item) => item.name === "Inbox" || item.name === "ReviewedIgnore"
            );
            setEmailFolder(filteredResponse);
            setloading(false);
        } catch (error) {
            console.error("EmailQueues Error:", error);
        }
    };

    const handleGridRefresh = () => {
        fetchQueueEmailData();
    };
    useEffect(() => {
        if (folderListValue !== "") {
            fetchQueueEmailData();
        }
    }, [folderListValue]);
    const fetchQueueEmailData = async () => {
        setloading(true);
        try {
            let data = {};
            if (folderListValue) {
                data.queueEmail = folderListValue;
            }
            if (formData) {
                if (formData.queueEmail) {
                    data.queueEmail = formData.queueEmail;
                }

                if (formData.subject) {
                    data.subject = formData.subject;
                }

                if (formData.senderEmail) {
                    data.senderEmail = formData.senderEmail;
                }

                if (formData && formData.fromDate) {
                    const formattedFromDate = moment(
                        formData.fromDate,
                        "DD/MM/YYYY"
                    ).format("YYYY-MM-DDTHH:mm:ss.SSS");
                    data.fromDate = formattedFromDate;
                }

                // Convert `toDate` to UTC and format it
                if (formData && formData.toDate) {
                    const formattedToDate = moment(formData.toDate, "DD/MM/YYYY").format(
                        "YYYY-MM-DDTHH:mm:ss.SSS"
                    );
                    data.toDate = formattedToDate;
                }

                if (formData.days) {
                    data.days = formData.days;
                }
                if (formData.referenceId) {
                    data.referenceId = formData.referenceId;
                }
            }
            if (inputValue && searchCategory) {
                data[searchCategory] = inputValue;
            }
            if (radioOption) {
                data.folder = radioOption;
            }

            const params = {
                pageNumber: listPagination.pageNumber,
                pageSize: listPagination.pageSize,
                select: 'id,folder,messageId,queueEmail,referenceId,senderEmail,subject,text,timestamp,importance',
                orderBy: sortedInfo.order
                    ? `${sortedInfo.columnKey}:${sortedInfo.order === "ascend" ? "Asc" : "Desc"
                    }`
                    : "timeStamp:Desc",
            };

            const response = await SharedService.post({
                token,
                url: "emailValidationQueue/search",
                data,
                params,
            });

            // Handle the response data
            setEmailQueueData(response.items);

            setlistPagination((prevPagination) => ({
                ...prevPagination,
                totalItemCount: response.totalItemCount,
            }));
            setloading(false);
            handleClose();
        } catch (error) {
            // Handle any errors
            setloading(false);

            if (error.response && error.response.status === 500) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }
            if (error.response && error.response.status === 502) {
                notification.error({
                    message: "Error",
                    description: error.response.statusText,
                });
            }

            console.error(error);
        }
    };

    useSelectedItems(formData.selectedItems, fetchQueueEmailData);
    const handleOptionRadioChange = (value) => {
        listPagination.pageNumber = 1;
        setRadioOption(value);
    };
    const handleSelectFolderChange = (value) => {
        setFolderListValue(value);
    };
    const handleSearchClick = () => {
        setEmailQueueIsOpen(true);
    };
    const handleClose = () => {
        setEmailQueueIsOpen(false);
    };

    const handleClearSearch = () => {
        setFormData({
            senderEmail: "",
            queueEmail: "",
            fromDate: "",
            toDate: "",
            days: null,
            selectedItems: [],
        });

        fetchQueueEmailData();
    };

    const handleRemoveSelectedItem = (itemIndex, key) => {
        setFormData((prevState) => {
            const updatedSelectedItems = prevState.selectedItems.map(
                (item, index) => {
                    if (index === itemIndex) {
                        const updatedItem = {...item};
                        delete updatedItem[key]; // Remove the specified key from the item
                        return updatedItem;
                    }
                    return item;
                }
            );
            let updatedInputValues = {...prevState};

            updatedInputValues[key] = "";

            return {
                ...updatedInputValues,
                selectedItems: updatedSelectedItems,
            };
        });
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: (keys, rows) => {
            setSelectedRowKeys(keys);
            setSelectedRows(rows);
        },
    };

    return (
        <div>
            <SEO {...pageSEOSettings} />
            <div>
                <MoveEmailModal
                    visible={open}
                    onClose={handleCancel}
                    folders={emailFolder}
                    currentFolder={folder}
                    loading={loading}
                    title={
                        isBulkMove
                            ? `Move ${selectedRows.length} email${selectedRows.length === 1 ? "" : "s"}`
                            : "Move email"
                    }
                    onMove={(folderGuid, name) => {
                        setValue(folderGuid);
                        setFolderName(name);
                        handleOk();
                    }}
                />
            </div>

            {/* Page header */}
            <div className="px-4 sm:px-7 py-5">
                <div className="flex items-start gap-4 flex-wrap">
                    <div className="flex-1 min-w-0">
                        <div className="text-[22px] font-semibold text-[#0B1220] leading-tight">Email Queues</div>
                        <div className="text-[13px] text-[#7A849A] mt-1">
                            Review and triage incoming supplier emails before they become invoices.
                        </div>
                    </div>
                    <div className="flex items-center gap-2">
                        <Button icon={<ReloadOutlined/>} onClick={handleGridRefresh}>
                            Refresh
                        </Button>
                        {selectedRowKeys.length > 0 && (
                            <Button type="primary" icon={<SwapOutlined/>} onClick={openBulkMoveModal}>
                                Move selected ({selectedRowKeys.length})
                            </Button>
                        )}
                    </div>
                </div>
            </div>

            {emailQueueIsOpen && (
                <EmailQueueSearchPopup
                    listPagination={listPagination}
                    fetchQueueEmailData={fetchQueueEmailData}
                    setFormData={setFormData}
                    formData={formData}
                    visible={emailQueueIsOpen}
                    onClose={handleClose}
                />
            )}

            <div className="px-4 sm:px-7 pb-7 relative">
                {loading && (
                    <div className="absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-10 rounded-[14px]">
                        <Spin size="large" className="custom-spin"/>
                    </div>
                )}

                {/* Filters row */}
                <div className="flex items-center gap-3 flex-wrap mb-4">
                    <Select
                        placeholder="All mailboxes"
                        options={folderListData}
                        allowClear
                        onChange={handleSelectFolderChange}
                        className="w-[280px]"
                        value={folderListValue || undefined}
                    />
                    <Segmented
                        value={radioOption}
                        onChange={handleOptionRadioChange}
                        options={[
                            {value: 'forReview', label: (
                                <span className="flex items-center gap-1.5">
                                    <span className="inline-block w-2 h-2 rounded-full" style={{backgroundColor: EmailStatusColors.forReview}}/>
                                    For review
                                </span>
                            )},
                            {value: 'inbox', label: (
                                <span className="flex items-center gap-1.5">
                                    <span className="inline-block w-2 h-2 rounded-full" style={{backgroundColor: EmailStatusColors.inbox}}/>
                                    Inbox
                                </span>
                            )},
                            {value: 'processed', label: (
                                <span className="flex items-center gap-1.5">
                                    <span className="inline-block w-2 h-2 rounded-full" style={{backgroundColor: EmailStatusColors.processed}}/>
                                    Processed
                                </span>
                            )},
                            {value: 'reviewedIgnore', label: (
                                <span className="flex items-center gap-1.5">
                                    <span className="inline-block w-2 h-2 rounded-full" style={{backgroundColor: EmailStatusColors.reviewedIgnore}}/>
                                    Reviewed / Ignored
                                </span>
                            )},
                        ]}
                    />
                    <div className="flex-1"/>
                    <Button icon={<FilterOutlined/>} onClick={handleSearchClick}>Filters</Button>
                </div>

                {/* Applied search chips */}
                {formData?.selectedItems?.length > 0 &&
                    formData?.selectedItems[0] &&
                    Object.keys(formData.selectedItems[0]).length > 0 && (
                    <div className="flex items-center gap-2 flex-wrap mb-4 p-3 bg-white border border-[#E4E7EE] rounded-[10px]">
                        <span className="text-[12px] uppercase tracking-wider text-[#7A849A] font-semibold">Filters</span>
                        {formData.selectedItems.slice(0, 2).map((item, index) => (
                            <React.Fragment key={index}>
                                {Object.keys(item).slice(0, 2).map((key) => (
                                    <Tag
                                        key={`${index}-${key}`}
                                        className="!m-0 inline-flex items-center gap-1 px-2.5 py-1 rounded-full"
                                        style={{backgroundColor: "#ECF9EE", color: "#1B7A31", border: "1px solid #C8E9CD"}}
                                    >
                                        <span className="font-semibold">{key}:</span>
                                        <span className="truncate max-w-[160px]">{item[key]}</span>
                                        <CloseOutlined
                                            className="cursor-pointer text-[10px]"
                                            onClick={() => handleRemoveSelectedItem(index, key)}
                                        />
                                    </Tag>
                                ))}
                            </React.Fragment>
                        ))}
                        {Object.keys(formData.selectedItems[0]).length > 2 && (
                            <Button size="small" type="link" onClick={handleSearchClick}>
                                +{Object.keys(formData.selectedItems[0]).length - 2} more
                            </Button>
                        )}
                        <div className="flex-1"/>
                        <Button size="small" type="link" onClick={handleClearSearch}>
                            Clear all
                        </Button>
                    </div>
                )}

                <Table
                    rowSelection={rowSelection}
                    pagination={paginationProps}
                    onChange={handleTableChange}
                    rowKey="id"
                    columns={columns}
                    dataSource={emailQueueData}
                    scroll={{x: 960}}
                />
            </div>
        </div>
    );
}

export default EmailQueues;
